import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { INFO_CARDS } from "../mock";

const InfoGrid = () => {
  return (
    <section className="relative z-10 mx-auto max-w-6xl px-4 pb-16 md:px-8">
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {INFO_CARDS.map((c) => (
          <div
            key={c.title}
            className="group flex flex-col rounded-md border border-white/10 bg-[#242424] p-6 text-center shadow-lg transition-all duration-300 hover:border-[#e0a82e]/50 hover:bg-[#2b2b2b]"
          >
            <h3 className="font-display text-xl font-600 uppercase tracking-wide text-[#f2f2f2]">
              {c.title}
            </h3>
            <p className="mt-3 flex-1 text-sm leading-relaxed text-[#bcbcbc]">
              {c.description}
            </p>
            <Link
              to={c.to}
              className="mx-auto mt-5 inline-flex items-center gap-2 font-display text-sm font-600 uppercase tracking-wide text-[#e0a82e] transition-colors duration-200 hover:text-[#f2b93f]"
            >
              {c.cta} <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
};

export default InfoGrid;
